module.exports = __webpack_public_path__ + "static/img/image.2c0fea4e.png";